import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { restoreApplicationFailed, restoreApplicationSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { NO_CONTENT } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* restoreApplication(action) {
  try {
    const url = `${BACKEND_URL}/resources/applications/${action.payload}/restore`;
    const dataResponse = yield makeRequest(url, {}, action, 'POST', true);
    if (dataResponse.status === NO_CONTENT) {
      yield put(restoreApplicationSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      const data = yield getBodyJson(dataResponse);
      yield put(restoreApplicationFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(restoreApplicationFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
